import React, { useState, useEffect, useRef, useCallback } from "react";

const slides = [
  {
    tag: "HOT",
    tagBg: "#ef4444",
    tagColor: "#fff",
    text: (
      <>
        <b style={{ color: "#fde68a" }}>Flat 10% OFF</b> on all Lithium
        Batteries
      </>
    ),
    coupon: "LITHO10",
  },
  {
    tag: "CODE",
    tagBg: "#eab308",
    tagColor: "#1a1a00",
    text: (
      <>
        Extra <b style={{ color: "#fde68a" }}>₹500 OFF</b> on orders above ₹5000
      </>
    ),
    coupon: "ZYNC500",
  },
  // {
  //   tag: "NEW",
  //   tagBg: "#22c55e",
  //   tagColor: "#fff",
  //   text: (
  //     <>
  //       Zynventics launching soon! —{" "}
  //       <b style={{ color: "#fde68a" }}>Free Shipping</b> sitewide
  //     </>
  //   ),
  // },
  {
    tag: "DEAL",
    tagBg: "#eab308",
    tagColor: "#1a1a00",
    text: (
      <>
        <b style={{ color: "#fde68a" }}>First Order?</b> Get 10% off
      </>
    ),
    coupon: "WELCOME10",
  },
];

const AnnouncementBanner = () => {
  const [current, setCurrent] = useState(0);
  const [anim, setAnim] = useState("active");
  const [copied, setCopied] = useState(false);
  const timerRef = useRef(null);

  // ✅ useCallback makes goTo stable — safe to use in useEffect deps
  const goTo = useCallback((next) => {
    setAnim("exit");
    setTimeout(() => {
      setCurrent((next + slides.length) % slides.length);
      setAnim("active");
    }, 380);
  }, []); // no external deps — slides is module-level constant

  useEffect(() => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => goTo(current + 1), 3500);
    return () => clearInterval(timerRef.current);
  }, [current, goTo]); // ✅ both deps listed, no warning

  const handleCopy = (code) => {
    navigator.clipboard.writeText(code).catch(() => {});
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  };

  const slide = slides[current];

  return (
    <div
      style={{
        width: "100%",
        background: "#1a1a2e",
        color: "#fff",
        height: "38px",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        fontFamily: "sans-serif",
        flexShrink: 0,
      }}
    >
      <button
        onClick={() => {
          clearInterval(timerRef.current);
          goTo(current - 1);
        }}
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          height: "100%",
          width: "32px",
          background: "none",
          border: "none",
          color: "rgba(255,255,255,0.5)",
          fontSize: "14px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        ←
      </button>

      <div
        style={{
          width: "calc(100% - 64px)",
          height: "38px",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "7px",
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            opacity: anim === "active" ? 1 : 0,
            transform:
              anim === "active" ? "translateY(0)" : "translateY(-100%)",
            transition: "opacity 0.38s ease, transform 0.38s ease",
          }}
        >
          <span
            style={{
              fontSize: "9px",
              fontWeight: 700,
              padding: "1px 6px",
              borderRadius: "20px",
              letterSpacing: "0.07em",
              textTransform: "uppercase",
              background: slide.tagBg,
              color: slide.tagColor,
              flexShrink: 0,
              lineHeight: "1.7",
            }}
          >
            {slide.tag}
          </span>

          <span
            style={{
              fontSize: "12px",
              color: "rgba(255,255,255,0.92)",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              flexShrink: 1,
              minWidth: 0,
            }}
          >
            {slide.text}
          </span>

          {slide.coupon && (
            <div
              onClick={() => handleCopy(slide.coupon)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                background: "rgba(255,255,255,0.12)",
                border: "1px dashed rgba(255,255,255,0.45)",
                borderRadius: "4px",
                padding: "1px 7px",
                fontFamily: "monospace",
                fontSize: "11px",
                fontWeight: 600,
                letterSpacing: "0.09em",
                cursor: "pointer",
                flexShrink: 0,
                whiteSpace: "nowrap",
                lineHeight: "1.7",
              }}
            >
              {slide.coupon} 📋
              {copied && (
                <span style={{ fontSize: "9px", color: "#4ade80" }}>✓</span>
              )}
            </div>
          )}
        </div>
      </div>

      <button
        onClick={() => {
          clearInterval(timerRef.current);
          goTo(current + 1);
        }}
        style={{
          position: "absolute",
          right: 0,
          top: 0,
          height: "100%",
          width: "32px",
          background: "none",
          border: "none",
          color: "rgba(255,255,255,0.5)",
          fontSize: "14px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        →
      </button>
    </div>
  );
};

export default AnnouncementBanner;
